export default __webpack_public_path__ + "static/media/public-key.801bca17.svg";